import { CommonModule } from '@angular/common';
import { Component, inject, signal } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';

import { TranslateLangPipe } from '../../pipes/translate-lang.pipe';
import { SupportTopic } from '../support-topics/support-topics.component';

export interface SupportTopicsFaqBottomSheetData {
  topic: SupportTopic;
}

/**
 * Mobile-only FAQ accordion for a single support topic, opened from the
 * Support Topics sidebar as a bottom sheet (see SupportTopicsComponent).
 */
@Component({
  selector: 'app-support-topics-faq-bottom-sheet',
  standalone: true,
  imports: [CommonModule, TranslateLangPipe],
  templateUrl: './support-topics-faq-bottom-sheet.component.html',
  styleUrl: './support-topics-faq-bottom-sheet.component.scss',
})
export class SupportTopicsFaqBottomSheetComponent {
  private readonly bottomSheetRef = inject(MatBottomSheetRef<SupportTopicsFaqBottomSheetComponent>);
  readonly data = inject<SupportTopicsFaqBottomSheetData>(MAT_BOTTOM_SHEET_DATA);

  expandedIndex = signal<number>(-1);

  toggleFaq(index: number): void {
    this.expandedIndex.update((current) => (current === index ? -1 : index));
  }

  close(): void {
    this.bottomSheetRef.dismiss();
  }
}
